import { triggerNotification } from "../../../../common/CommonExport";

export function formatJobType(jobType: any) {
  const mapping: any = {
    FULL_TIME: "Full-time",
    PART_TIME: "Part-time",
    CONTRACT: "Contract",
    INTERNSHIP: "Internship",
  };
  return mapping[jobType];
}
export const filterJobList = [
  {
    value: "FULL_TIME",
    label: "Full Time",
  },
  {
    value: "PART_TIME",
    label: "Part Time",
  },
  {
    value: "CONTRACT",
    label: "Contract",
  },
  {
    value: "INTERNSHIP",
    label: "Internship",
  },
];

export const statusList = [
  {
    value: "OPEN",
    label: "OPEN",
  },
  {
    value: "CLOSED",
    label: "CLOSED",
  },
  {
    value: "ON_HOLD",
    label: "ON-HOLD",
  },
];

export function capitalizeFirstLetter(inputText: any) {
  console.log(" inputText:", inputText);
  if (!inputText) return "";
  return inputText.charAt(0).toUpperCase() + inputText.slice(1);
}
interface FunctionProps {
  [key: string]: any;
}

export const createPayload = ({ editRecord, values, isEdit }: FunctionProps) => ({
  talentRequisitionFormId: editRecord?.key,
  jobTitle: values?.positionTitle,
  designation: {
    designationId: values?.designationId,
  },
  hiringManagerId: values?.hiringManagerId,
  organisationId: values?.organisationId,
  numPositions: values?.personsRequired,
  gender: values?.gender,
  ageGroup: values?.ageGroup,
  jobType: values?.jobType?.replace(/_/g, " "),
  requiredSkills: values?.additionalInput,
  salaryRange: values?.ctc,
  expectedDateOfJoining: values?.positionFillDate,
  status: isEdit ? values?.status : "OPEN",
  createdBy: {
    employeeId: values?.employeeId,
  },
  requisitionNo: values?.requisitionNo,
  educationBackground: values?.educationBackground,
  experienceRequired: values?.experienceRequired,
  isJdExists: values?.existingJD,
  incumbentName: values?.lastIncumbent,
  reportingPerson: values?.reportingPerson,
  preparedBy: values?.reportingPerson,
  isActive: true,
});
export const getTrfDetails = async (props: FunctionProps) => {
  const { orgName, trfDetailsApi, editRecord, setInitialValues, initialValues, setLoader } = props;
  try {
    const response: any = await trfDetailsApi("", {}, { id: editRecord?.key });
    if (response?.status === 200) {
      const data = response?.data?.data;
      setInitialValues({
        ...initialValues,
        trfGeneration: true, // make sure true white edit
        requisitionNo: data?.requisitionNo?.toString() || "",
        company: data?.companyName || orgName || "",
        organisationId: data?.organisationId || "",
        positionTitle: data?.designation?.name || "",
        designationId: data?.designation?.designationId || "",
        department: data?.designation?.departmentName || "",
        hiringManagerId: data?.hiringManagerId || "",
        reportingPerson: data?.createdBy.firstName + " " + data?.createdBy?.lastName || "",
        preparedBy: data?.createdBy.firstName + " " + data?.createdBy?.lastName || "",
        personsRequired: data?.numPositions || 1,
        ctc: data?.salaryRange || "",
        gender: data?.gender || "",
        ageGroup: data?.ageGroup || "",
        educationBackground: data?.educationBackground || "",
        experienceRequired: data?.experienceRequired || "",
        lastIncumbent: data?.incumbentName || "",
        positionFillDate: data?.expectedDateOfJoining || "",
        existingJD: data?.isJdExists,
        additionalInput: data?.requiredSkills || "",
        jobType: data?.jobType ? formatJobType(data?.jobType) : "",
        employeeId: data?.createdBy?.employeeId || "",
        status: data?.status || "",
        approvedBy: "",
      });
      setLoader(false);
    }
    setLoader(false);
  } catch (err: any) {
    triggerNotification("error", "", err?.message || "Something went wrong", "topRight");
    setLoader(false);
  }
};

export const handleDeleteTrf = async (props: any) => {
  const { deleteTRF, deleteArray, setModalErrMessage, setModalResponse, handleClosePopUpModal, designationGetApi, searchQuery, setPopModal } = props;
  try {
    const response = await deleteTRF("", {}, deleteArray);
    if (response?.status === 200) {
      setPopModal(true);
      setModalErrMessage(response?.data?.status?.message || "TRF deleted successfully");
      setModalResponse("success");
      setTimeout(() => {
        handleClosePopUpModal();
        designationGetApi(searchQuery);
      }, 2000);
    }
  } catch (error: any) {
    setModalErrMessage(error?.message || "Failed to delete TRF");
    setModalResponse("error");
    setTimeout(() => {
      handleClosePopUpModal();
    }, 1500);
  }
};

export const trfCreateEditApi = async (props: FunctionProps) => {
  const { setLoader, payload, trfDetailUpdate, editRecord, setModalOpen, setModalResponse, setModalMessage, handleClosePopUpModal, handleClose, designationGetApi, searchQuery, setModalButton } =
    props;
  setLoader(true);
  try {
    const response: any = await trfDetailUpdate(payload, {}, { id: editRecord?.key });
    if (response?.status === 200) {
      const responseMessage = response?.data?.status?.message;
      setModalOpen(true);
      setModalResponse("success");
      setModalMessage(responseMessage);
      setTimeout(() => {
        handleClosePopUpModal();
        handleClose();
        designationGetApi(searchQuery);
      }, 1500);
    }
    setLoader(false);
  } catch (err: any) {
    setLoader(false);
    setModalButton(true);
    setModalOpen(true);
    setModalResponse("error");
    setModalMessage(err?.message || "Something went wrong");
  }
};
